// import { useEffect, useMemo, useRef, useState } from "react";
// import {
//   createNews,
//   removeNews,
//   searchProductsByName,
//   subscribeAllNews,
//   updateNews,
// } from "../../../services/commercialNewsService";
// import transliterate from "../../../function/transliterate";
// import s from "./CommercialNewsAdmin.module.css";

// // простенький прев’ю банера прямо в адмінці
// function NewsPreview({ item }) {
//   if (!item) return null;
//   const slug =
//     item?.linkedProduct?.slug ||
//     (item?.linkedProduct?.bookName
//       ? transliterate(item.linkedProduct.bookName)
//       : "");
//   return (
//     <div className={s.previewWrap}>
//       <div className={s.previewLeft}>
//         {item.imageUrl ? (
//           <img src={item.imageUrl} alt={item.imageAlt || item.title} />
//         ) : (
//           <div className={s.previewImgStub}>Картинка</div>
//         )}
//         <div className={s.badge}>Комерційна новина</div>
//       </div>
//       <div className={s.previewRight}>
//         <div className={s.kicker}>Комерційні новини</div>
//         <div className={s.title}>{item.title || "Заголовок"}</div>
//         {item.subtitle && <div className={s.subtitle}>{item.subtitle}</div>}
//         <div className={s.cta}>→ Перейти: /product/{slug}</div>
//       </div>
//     </div>
//   );
// }

// // форма редагування/створення
// function EditorModal({ open, onClose, initial }) {
//   const [draft, setDraft] = useState(
//     initial || {
//       title: "",
//       subtitle: "",
//       bodyHtml: "",
//       imageUrl: "",
//       imageAlt: "",
//       linkedProduct: null,
//       ctaText: "Детальніше",
//       active: true,
//       pinned: false,
//       weight: 0,
//       startAt: null,
//       endAt: null,
//     }
//   );
//   const [file, setFile] = useState(null);
//   const [saving, setSaving] = useState(false);

//   const [q, setQ] = useState("");
//   const [results, setResults] = useState([]);
//   const debounceRef = useRef(null);

//   useEffect(() => {
//     if (!open) return;
//     setDraft(
//       initial || {
//         title: "",
//         subtitle: "",
//         bodyHtml: "",
//         imageUrl: "",
//         imageAlt: "",
//         linkedProduct: null,
//         ctaText: "Детальніше",
//         active: true,
//         pinned: false,
//         weight: 0,
//         startAt: null,
//         endAt: null,
//       }
//     );
//     setFile(null);
//     setQ("");
//     setResults([]);
//   }, [open, initial]);

//   useEffect(() => {
//     if (!q.trim()) {
//       setResults([]);
//       return;
//     }
//     clearTimeout(debounceRef.current);
//     debounceRef.current = setTimeout(async () => {
//       const arr = await searchProductsByName(q, 12);
//       setResults(arr);
//     }, 350);
//     return () => clearTimeout(debounceRef.current);
//   }, [q]);

//   const onPick = (prod) => {
//     const slug = transliterate(prod.bookName || "");
//     setDraft((d) => ({
//       ...d,
//       linkedProduct: {
//         uid: prod.uid || prod.id,
//         bookName: prod.bookName,
//         slug,
//       },
//     }));
//   };

//   const onSave = async () => {
//     if (!draft.title?.trim()) return alert("Вкажіть заголовок");
//     if (!draft.linkedProduct?.uid)
//       return alert("Оберіть книгу (прив’язка обов’язкова)");
//     setSaving(true);
//     try {
//       if (initial?.id) {
//         await updateNews(initial.id, draft, file || null);
//       } else {
//         await createNews(draft, file || null);
//       }
//       onClose(true);
//     } catch (e) {
//       console.error(e);
//       alert("Не вдалося зберегти. Перевірте консоль.");
//     } finally {
//       setSaving(false);
//     }
//   };

//   if (!open) return null;

//   return (
//     <div className={s.modalOverlay} onClick={() => onClose(false)}>
//       <div className={s.modal} onClick={(e) => e.stopPropagation()}>
//         <div className={s.modalHead}>
//           <div className={s.modalTitle}>
//             {initial?.id ? "Редагувати новину" : "Створити новину"}
//           </div>
//           <button className={s.iconBtn} onClick={() => onClose(false)}>
//             ✕
//           </button>
//         </div>

//         <div className={s.formGrid}>
//           <label className={s.field}>
//             <span>Заголовок</span>
//             <input
//               className={s.input}
//               value={draft.title}
//               onChange={(e) => setDraft({ ...draft, title: e.target.value })}
//             />
//           </label>

//           <label className={s.field}>
//             <span>Підзаголовок</span>
//             <textarea
//               className={s.textarea}
//               rows={3}
//               value={draft.subtitle}
//               onChange={(e) => setDraft({ ...draft, subtitle: e.target.value })}
//             />
//           </label>

//           <label className={s.field}>
//             <span>Картинка банера</span>
//             <input
//               className={s.input}
//               type="file"
//               accept="image/*"
//               onChange={(e) => setFile(e.target.files?.[0] || null)}
//             />
//             {!!draft.imageUrl && !file && (
//               <div className={s.helper}>Залишиться існуюча картинка</div>
//             )}
//           </label>

//           <label className={s.field}>
//             <span>Alt (опис картинки)</span>
//             <input
//               className={s.input}
//               value={draft.imageAlt}
//               onChange={(e) => setDraft({ ...draft, imageAlt: e.target.value })}
//             />
//           </label>

//           <label className={s.field}>
//             <span>CTA (текст кнопки)</span>
//             <input
//               className={s.input}
//               value={draft.ctaText}
//               onChange={(e) => setDraft({ ...draft, ctaText: e.target.value })}
//             />
//           </label>

//           <div className={s.row}>
//             <label className={s.check}>
//               <input
//                 type="checkbox"
//                 checked={!!draft.active}
//                 onChange={(e) =>
//                   setDraft({ ...draft, active: e.target.checked })
//                 }
//               />
//               Активна
//             </label>
//             <label className={s.check}>
//               <input
//                 type="checkbox"
//                 checked={!!draft.pinned}
//                 onChange={(e) =>
//                   setDraft({ ...draft, pinned: e.target.checked })
//                 }
//               />
//               Закріпити
//             </label>
//             <label className={s.fieldInline}>
//               <span>Вага</span>
//               <input
//                 className={s.inputN}
//                 type="number"
//                 value={draft.weight}
//                 onChange={(e) =>
//                   setDraft({ ...draft, weight: Number(e.target.value || 0) })
//                 }
//               />
//             </label>
//           </div>

//           {/* Прив’язка до книги */}
//           <div className={s.card}>
//             <div className={s.cardTitle}>Прив’язка до книги</div>
//             <div className={s.row}>
//               <input
//                 className={s.input}
//                 placeholder="Пошук книги за назвою…"
//                 value={q}
//                 onChange={(e) => setQ(e.target.value)}
//               />
//             </div>
//             {!!results.length && (
//               <div className={s.searchList}>
//                 {results.map((p) => (
//                   <div
//                     key={p.uid || p.id}
//                     className={s.searchItem}
//                     onClick={() => onPick(p)}
//                   >
//                     <div className={s.siTitle}>{p.bookName}</div>
//                     <div className={s.siSub}>
//                       uid: {p.uid || p.id}
//                       {p.yearGroup?.length
//                         ? ` · вік: ${p.yearGroup.join(", ")}`
//                         : ""}
//                     </div>
//                   </div>
//                 ))}
//               </div>
//             )}
//             {draft.linkedProduct?.uid ? (
//               <div className={s.picked}>
//                 Обрано: <b>{draft.linkedProduct.bookName}</b>{" "}
//                 <span className={s.dim}>({draft.linkedProduct.uid})</span>
//               </div>
//             ) : (
//               <div className={s.helper}>Оберіть книгу зі списку вище</div>
//             )}
//           </div>

//           {/* Прев’ю */}
//           <div className={s.card}>
//             <div className={s.cardTitle}>Прев’ю</div>
//             <NewsPreview
//               item={{
//                 ...draft,
//                 imageUrl: file
//                   ? URL.createObjectURL(file)
//                   : draft.imageUrl || "",
//               }}
//             />
//           </div>
//         </div>

//         <div className={s.modalFoot}>
//           <button className={s.btn} onClick={() => onClose(false)}>
//             Відмінити
//           </button>
//           <button className={s.btnPrimary} disabled={saving} onClick={onSave}>
//             {saving ? "Збереження…" : "Зберегти"}
//           </button>
//         </div>
//       </div>
//     </div>
//   );
// }

// export default function CommercialNewsAdmin() {
//   const [items, setItems] = useState([]);
//   const [open, setOpen] = useState(false);
//   const [edit, setEdit] = useState(null);

//   useEffect(() => {
//     const unsub = subscribeAllNews(setItems);
//     return () => unsub && unsub();
//   }, []);

//   const onCreate = () => {
//     setEdit(null);
//     setOpen(true);
//   };
//   const onEdit = (it) => {
//     setEdit(it);
//     setOpen(true);
//   };

//   const toggleActive = async (it) => {
//     await updateNews(it.id, { active: !it.active });
//   };
//   const togglePinned = async (it) => {
//     await updateNews(it.id, { pinned: !it.pinned });
//   };
//   const onRemove = async (it) => {
//     if (!window.confirm("Видалити цю новину?")) return;
//     await removeNews(it.id);
//   };

//   return (
//     <div className={s.page}>
//       <div className={s.topbar}>
//         <h1 className={s.heading}>Комерційні новини</h1>
//         <button className={s.btnPrimary} onClick={onCreate}>
//           + Створити новину
//         </button>
//       </div>

//       <div className={s.list}>
//         {items.length === 0 && (
//           <div className={s.empty}>
//             Новин поки немає. Натисніть «Створити новину».
//           </div>
//         )}
//         {items.map((it) => (
//           <div key={it.id} className={s.item}>
//             <div className={s.thumb}>
//               {it.imageUrl ? (
//                 <img src={it.imageUrl} alt={it.title} />
//               ) : (
//                 <div className={s.thumbStub} />
//               )}
//             </div>
//             <div className={s.meta}>
//               <div className={s.titleRow}>
//                 <div className={s.title}>{it.title}</div>
//                 {it.pinned && <span className={s.pill}>pinned</span>}
//                 {it.active ? (
//                   <span className={`${s.pill} ${s.green}`}>active</span>
//                 ) : (
//                   <span className={`${s.pill} ${s.gray}`}>inactive</span>
//                 )}
//               </div>
//               {it.subtitle && <div className={s.subtitle}>{it.subtitle}</div>}
//               <div className={s.subRow}>
//                 <div>
//                   Книга:{" "}
//                   {it.linkedProduct?.bookName ? (
//                     <b>{it.linkedProduct.bookName}</b>
//                   ) : (
//                     <i>не прив’язано</i>
//                   )}
//                 </div>
//                 <div className={s.dim}>вага: {Number(it.weight || 0)}</div>
//               </div>
//             </div>
//             <div className={s.actions}>
//               <button className={s.btn} onClick={() => onEdit(it)}>
//                 Редагувати
//               </button>
//               <button className={s.btn} onClick={() => togglePinned(it)}>
//                 {it.pinned ? "Відкріпити" : "Закріпити"}
//               </button>
//               <button className={s.btn} onClick={() => toggleActive(it)}>
//                 {it.active ? "Деактивувати" : "Активувати"}
//               </button>
//               <button className={s.btnGhost} onClick={() => onRemove(it)}>
//                 Видалити
//               </button>
//             </div>
//           </div>
//         ))}
//       </div>

//       <EditorModal
//         open={open}
//         initial={edit}
//         onClose={(changed) => {
//           setOpen(false);
//           setEdit(null);
//           // список оновиться автоматично через subscribeAllNews
//         }}
//       />
//     </div>
//   );
// }
import { useEffect, useMemo, useRef, useState } from "react";
import {
  createNews,
  removeNews,
  searchProductsByName,
  subscribeAllNews,
  updateNews,
} from "../../../services/commercialNewsService";
import transliterate from "../../../function/transliterate";

/* ========== Preview ========== */
function NewsPreview({ item }) {
  if (!item) return null;
  const slug =
    item?.linkedProduct?.slug ||
    (item?.linkedProduct?.bookName
      ? transliterate(item.linkedProduct.bookName)
      : "");
  return (
    <div className="cn-previewWrap">
      <div className="cn-previewLeft">
        {item.imageUrl ? (
          <img src={item.imageUrl} alt={item.imageAlt || item.title} />
        ) : (
          <div className="cn-previewImgStub">Картинка</div>
        )}
        <div className="cn-badge">Комерційна новина</div>
      </div>
      <div className="cn-previewRight">
        <div className="cn-kicker">Комерційні новини</div>
        <div className="cn-title">{item.title || "Заголовок"}</div>
        {item.subtitle && <div className="cn-subtitle">{item.subtitle}</div>}
        <div className="cn-cta">→ Перейти: /product/{slug}</div>
      </div>
    </div>
  );
}

/* ========== Modal Editor ========== */
function EditorModal({ open, onClose, initial }) {
  const [draft, setDraft] = useState(
    initial || {
      title: "",
      subtitle: "",
      bodyHtml: "",
      imageUrl: "",
      imageAlt: "",
      linkedProduct: null,
      ctaText: "Детальніше",
      active: true,
      pinned: false,
      weight: 0,
      startAt: null,
      endAt: null,
    }
  );
  const [file, setFile] = useState(null);
  const [saving, setSaving] = useState(false);

  const [q, setQ] = useState("");
  const [results, setResults] = useState([]);
  const debounceRef = useRef(null);

  useEffect(() => {
    if (!open) return;
    setDraft(
      initial || {
        title: "",
        subtitle: "",
        bodyHtml: "",
        imageUrl: "",
        imageAlt: "",
        linkedProduct: null,
        ctaText: "Детальніше",
        active: true,
        pinned: false,
        weight: 0,
        startAt: null,
        endAt: null,
      }
    );
    setFile(null);
    setQ("");
    setResults([]);
  }, [open, initial]);

  useEffect(() => {
    if (!q.trim()) {
      setResults([]);
      return;
    }
    clearTimeout(debounceRef.current);
    debounceRef.current = setTimeout(async () => {
      const arr = await searchProductsByName(q, 12);
      setResults(arr);
    }, 350);
    return () => clearTimeout(debounceRef.current);
  }, [q]);

  const onPick = (prod) => {
    const slug = transliterate(prod.bookName || "");
    setDraft((d) => ({
      ...d,
      linkedProduct: {
        uid: prod.uid || prod.id,
        bookName: prod.bookName,
        slug,
      },
    }));
  };

  const onSave = async () => {
    if (!draft.title?.trim()) return alert("Вкажіть заголовок");
    if (!draft.linkedProduct?.uid)
      return alert("Оберіть книгу (прив’язка обов’язкова)");
    setSaving(true);
    try {
      if (initial?.id) {
        await updateNews(initial.id, draft, file || null);
      } else {
        await createNews(draft, file || null);
      }
      onClose(true);
    } catch (e) {
      console.error(e);
      alert("Не вдалося зберегти. Перевірте консоль.");
    } finally {
      setSaving(false);
    }
  };

  if (!open) return null;

  return (
    <div className="cn-modalOverlay" onClick={() => onClose(false)}>
      <div className="cn-modal" onClick={(e) => e.stopPropagation()}>
        <div className="cn-modalHead">
          <div className="cn-modalTitle">
            {initial?.id ? "Редагувати новину" : "Створити новину"}
          </div>
          <button className="cn-iconBtn" onClick={() => onClose(false)}>
            ✕
          </button>
        </div>

        <div className="cn-formGrid">
          <label className="cn-field">
            <span>Заголовок</span>
            <input
              className="cn-input"
              value={draft.title}
              onChange={(e) => setDraft({ ...draft, title: e.target.value })}
            />
          </label>

          <label className="cn-field">
            <span>Підзаголовок</span>
            <textarea
              className="cn-textarea"
              rows={3}
              value={draft.subtitle}
              onChange={(e) => setDraft({ ...draft, subtitle: e.target.value })}
            />
          </label>

          <label className="cn-field">
            <span>Картинка банера</span>
            <label className="cn-fileBtn">
              <input
                type="file"
                accept="image/*"
                onChange={(e) => setFile(e.target.files?.[0] || null)}
              />
              Обрати зображення
            </label>
            {!!draft.imageUrl && !file && (
              <div className="cn-helper">Залишиться існуюча картинка</div>
            )}
          </label>

          <label className="cn-field">
            <span>Alt (опис картинки)</span>
            <input
              className="cn-input"
              value={draft.imageAlt}
              onChange={(e) => setDraft({ ...draft, imageAlt: e.target.value })}
            />
          </label>

          <label className="cn-field">
            <span>CTA (текст кнопки)</span>
            <input
              className="cn-input"
              value={draft.ctaText}
              onChange={(e) => setDraft({ ...draft, ctaText: e.target.value })}
            />
          </label>

          <div className="cn-row">
            <label className="cn-check">
              <input
                type="checkbox"
                checked={!!draft.active}
                onChange={(e) =>
                  setDraft({ ...draft, active: e.target.checked })
                }
              />
              Активна
            </label>
            <label className="cn-check">
              <input
                type="checkbox"
                checked={!!draft.pinned}
                onChange={(e) =>
                  setDraft({ ...draft, pinned: e.target.checked })
                }
              />
              Закріпити
            </label>
            <label className="cn-fieldInline">
              <span>Вага</span>
              <input
                className="cn-inputN"
                type="number"
                value={draft.weight}
                onChange={(e) =>
                  setDraft({ ...draft, weight: Number(e.target.value || 0) })
                }
              />
            </label>
          </div>

          {/* Прив’язка до книги */}
          <div className="cn-card">
            <div className="cn-cardTitle">Прив’язка до книги</div>
            <div className="cn-row">
              <input
                className="cn-input"
                placeholder="Пошук книги за назвою…"
                value={q}
                onChange={(e) => setQ(e.target.value)}
              />
            </div>
            {!!results.length && (
              <div className="cn-searchList">
                {results.map((p) => (
                  <div
                    key={p.uid || p.id}
                    className="cn-searchItem"
                    onClick={() => onPick(p)}
                  >
                    <div className="cn-siTitle">{p.bookName}</div>
                    <div className="cn-siSub">
                      uid: {p.uid || p.id}
                      {p.yearGroup?.length
                        ? ` · вік: ${p.yearGroup.join(", ")}`
                        : ""}
                    </div>
                  </div>
                ))}
              </div>
            )}
            {draft.linkedProduct?.uid ? (
              <div className="cn-picked">
                Обрано: <b>{draft.linkedProduct.bookName}</b>{" "}
                <span className="cn-dim">({draft.linkedProduct.uid})</span>
              </div>
            ) : (
              <div className="cn-helper">Оберіть книгу зі списку вище</div>
            )}
          </div>

          {/* Прев’ю */}
          <div className="cn-card">
            <div className="cn-cardTitle">Прев’ю</div>
            <NewsPreview
              item={{
                ...draft,
                imageUrl: file
                  ? URL.createObjectURL(file)
                  : draft.imageUrl || "",
              }}
            />
          </div>
        </div>

        <div className="cn-modalFoot">
          <button className="cn-btn" onClick={() => onClose(false)}>
            Відмінити
          </button>
          <button className="cn-btnPrimary" disabled={saving} onClick={onSave}>
            {saving ? "Збереження…" : "Зберегти"}
          </button>
        </div>
      </div>
    </div>
  );
}

/* ========== Page ========== */
export default function CommercialNewsAdmin() {
  const [items, setItems] = useState([]);
  const [open, setOpen] = useState(false);
  const [edit, setEdit] = useState(null);

  useEffect(() => {
    const unsub = subscribeAllNews(setItems);
    return () => unsub && unsub();
  }, []);

  const onCreate = () => {
    setEdit(null);
    setOpen(true);
  };
  const onEdit = (it) => {
    setEdit(it);
    setOpen(true);
  };

  const toggleActive = async (it) => {
    await updateNews(it.id, { active: !it.active });
  };
  const togglePinned = async (it) => {
    await updateNews(it.id, { pinned: !it.pinned });
  };
  const onRemove = async (it) => {
    if (!window.confirm("Видалити цю новину?")) return;
    await removeNews(it.id);
  };

  return (
    <div className="cn-page">
      <style>{CSS}</style>

      <div className="cn-topbar">
        <h1 className="cn-heading">Комерційні новини</h1>
        <button className="cn-btnPrimary" onClick={onCreate}>
          + Створити новину
        </button>
      </div>

      <div className="cn-list">
        {items.length === 0 && (
          <div className="cn-empty">
            Новин поки немає. Натисніть «Створити новину».
          </div>
        )}

        {items.map((it) => (
          <div key={it.id} className="cn-item">
            <div className="cn-thumb">
              {it.imageUrl ? (
                <img src={it.imageUrl} alt={it.title} />
              ) : (
                <div className="cn-thumbStub" />
              )}
            </div>

            <div className="cn-meta">
              <div className="cn-titleRow">
                <div className="cn-titleLine">
                  <div className="cn-title">{it.title}</div>
                  {it.pinned && <span className="cn-pill">pinned</span>}
                  {it.active ? (
                    <span className="cn-pill cn-green">active</span>
                  ) : (
                    <span className="cn-pill cn-gray">inactive</span>
                  )}
                </div>
                {it.subtitle && (
                  <div className="cn-subtitle">{it.subtitle}</div>
                )}
              </div>

              <div className="cn-subRow">
                <div>
                  Книга:{" "}
                  {it.linkedProduct?.bookName ? (
                    <b>{it.linkedProduct.bookName}</b>
                  ) : (
                    <i>не прив’язано</i>
                  )}
                </div>
                <div className="cn-dim">вага: {Number(it.weight || 0)}</div>
              </div>
            </div>

            <div className="cn-actions">
              <button className="cn-btn" onClick={() => onEdit(it)}>
                Редагувати
              </button>
              <button className="cn-btn" onClick={() => togglePinned(it)}>
                {it.pinned ? "Відкріпити" : "Закріпити"}
              </button>
              <button className="cn-btn" onClick={() => toggleActive(it)}>
                {it.active ? "Деактивувати" : "Активувати"}
              </button>
              <button className="cn-btnGhost" onClick={() => onRemove(it)}>
                Видалити
              </button>
            </div>
          </div>
        ))}
      </div>

      <EditorModal
        open={open}
        initial={edit}
        onClose={() => {
          setOpen(false);
          setEdit(null);
        }}
      />
    </div>
  );
}

/* ===== CSS-in-JSX ===== */
const CSS = `
:root{
  --bg:#f7f9fc;
  --panel:#ffffff;
  --card:#ffffff;
  --muted:#667085;
  --text:#0f172a;
  --accent:#2563eb;
  --success:#16a34a;
  --warn:#f59e0b;
  --gray:#475569;
  --border:#e5e7eb;
  --radius:14px;
  --shadow:0 10px 28px rgba(2,6,23,.08);
}

*{box-sizing:border-box}
.cn-page{
  min-height:100%;
  background:var(--bg);
  color:var(--text);
  padding:28px 22px 40px;
}

.cn-topbar{
  display:flex; align-items:center; justify-content:space-between;
  gap:16px; margin-bottom:16px;
}
.cn-heading{ margin:0; font-size:26px; font-weight:800; letter-spacing:.2px; }

.cn-btnPrimary, .cn-btn, .cn-btnGhost{
  appearance:none; border:0; border-radius:12px; padding:10px 14px;
  font-weight:700; letter-spacing:.2px; cursor:pointer; transition:all .15s ease;
}
.cn-btnPrimary{
  background:var(--accent); color:#fff; box-shadow:0 10px 18px rgba(37,99,235,.18);
}
.cn-btnPrimary:hover{ filter:brightness(1.05); transform:translateY(-1px); }
.cn-btn{
  background:#fff; color:var(--text); border:1px solid var(--border);
}
.cn-btn:hover{ border-color:#cbd5e1; transform:translateY(-1px); }
.cn-btnGhost{
  background:transparent; color:#b42318; border:1px solid #f3d2cf;
}
.cn-btnGhost:hover{ background:#fff1f0; border-color:#ef9a9a; }

.cn-list{ display:flex; flex-direction:column; gap:12px; }
.cn-empty{
  background:#fff; border:1px dashed var(--border); border-radius:var(--radius);
  padding:18px; color:var(--muted); text-align:center;
}

.cn-item{
  background:var(--panel);
  border:1px solid var(--border);
  border-radius:var(--radius);
  display:grid;
  grid-template-columns: 168px 1fr auto;
  gap:16px;
  padding:14px;
  box-shadow:var(--shadow);
}
@media (max-width:980px){
  .cn-item{ grid-template-columns: 120px 1fr; }
  .cn-actions{ grid-column: 1 / -1; }
}

.cn-thumb{
  width:100%; height:120px; border-radius:12px; overflow:hidden; background:#f3f4f6;
  display:flex; align-items:center; justify-content:center; border:1px solid var(--border);
}
.cn-thumb img{ width:100%; height:100%; object-fit:cover; }
.cn-thumbStub{ width:100%; height:100%; background:repeating-linear-gradient(45deg,#f3f4f6,#f3f4f6 8px,#eef2f7 8px,#eef2f7 16px); }

.cn-meta{ display:flex; flex-direction:column; gap:8px; }
.cn-titleRow{ display:flex; flex-direction:column; gap:8px; }
.cn-titleLine{ display:flex; align-items:center; flex-wrap:wrap; gap:8px; }
.cn-title{ font-size:18px; font-weight:800; letter-spacing:.2px; }
.cn-subtitle{ color:var(--muted); line-height:1.45; }
.cn-subRow{ display:flex; align-items:center; gap:18px; color:#334155; }
.cn-dim{ color:#667085; }

.cn-pill{
  display:inline-flex; align-items:center; gap:6px;
  background:#f8fafc; color:#0f172a;
  border:1px solid var(--border);
  border-radius:999px; padding:4px 10px; font-size:12px; text-transform:uppercase; letter-spacing:.4px;
}
.cn-green{ background:#e7f6ec; color:#166534; border-color:#b6e2c3; }
.cn-gray{ background:#f3f4f6; color:#475569; border-color:#e5e7eb; }

.cn-actions{ display:flex; align-items:center; gap:8px; }

/* Modal */
.cn-modalOverlay{
  position:fixed; inset:0; background:rgba(0,0,0,.45);
  display:flex; align-items:center; justify-content:center; z-index:1000; padding:16px;
}
.cn-modal{
  width:min(1060px, 96vw); max-height:88vh; overflow:auto;
  background:var(--card); border:1px solid var(--border); border-radius:18px;
  box-shadow:var(--shadow); padding:16px;
}
.cn-modalHead{
  display:flex; align-items:center; justify-content:space-between; gap:10px; margin-bottom:10px;
}
.cn-modalTitle{ font-weight:800; font-size:18px; }
.cn-iconBtn{
  appearance:none; border:0; background:#fff; color:#1f2937; border:1px solid var(--border);
  border-radius:10px; width:36px; height:36px; cursor:pointer;
}
.cn-iconBtn:hover{ background:#f8fafc; }

.cn-formGrid{
  display:grid; gap:16px;
  grid-template-columns: repeat(2, minmax(0, 1fr));
}
@media (max-width:940px){
  .cn-formGrid{ grid-template-columns: 1fr; }
}
.cn-field{ display:flex; flex-direction:column; gap:8px; }
.cn-field > span{
  font-size:12px; color:var(--muted); text-transform:uppercase; letter-spacing:.4px;
}
.cn-input, .cn-textarea, .cn-inputN{
  width:100%; background:#fff; color:var(--text);
  border:1px solid var(--border); border-radius:10px; padding:12px 14px;
  outline:none; transition:border-color .2s, box-shadow .2s;
}
.cn-input:focus, .cn-textarea:focus, .cn-inputN:focus{
  border-color:var(--accent); box-shadow:0 0 0 3px rgba(37,99,235,.18);
}
.cn-textarea{ resize:vertical; line-height:1.5; }
.cn-inputN{ max-width:180px; }

.cn-row{ display:flex; flex-wrap:wrap; gap:12px; align-items:center; }
.cn-check{ display:flex; align-items:center; gap:8px; color:#111827; }
.cn-fieldInline{ display:flex; flex-direction:column; gap:6px; }

.cn-card{
  background:#fff; border:1px solid var(--border); border-radius:14px; padding:14px;
}
.cn-cardTitle{ font-weight:700; margin-bottom:10px; color:#1f2937; }

.cn-searchList{
  border:1px solid var(--border); border-radius:12px; overflow:hidden; margin-top:10px;
  max-height:240px; overflow:auto; background:#fff;
}
.cn-searchItem{
  padding:10px 12px; background:#fff; cursor:pointer; border-bottom:1px solid #f1f5f9;
}
.cn-searchItem:hover{ background:#f9fafb; }
.cn-siTitle{ font-weight:700; }
.cn-siSub{ color:#667085; font-size:12px; }

.cn-picked{ padding-top:8px; color:#111827; }
.cn-helper{ color:var(--muted); }

.cn-modalFoot{
  display:flex; justify-content:flex-end; gap:10px; margin-top:14px;
}
.cn-btn{ background:#fff; color:var(--text); border:1px solid var(--border); }
.cn-btn:hover{ border-color:#cbd5e1; transform:translateY(-1px); }
.cn-btnPrimary{
  background:var(--accent); color:#fff; border:0; border-radius:12px; padding:10px 14px;
  font-weight:700; box-shadow:0 10px 18px rgba(37,99,235,.18); cursor:pointer;
}
.cn-btnPrimary:hover{ filter:brightness(1.05); transform:translateY(-1px); }

/* Preview */
.cn-previewWrap{
  display:grid; grid-template-columns: 280px 1fr; gap:14px; align-items:flex-start;
  background:#fff; border:1px solid var(--border); border-radius:14px; padding:12px;
}
@media (max-width:940px){
  .cn-previewWrap{ grid-template-columns:1fr; }
}
.cn-previewLeft{
  position:relative; border-radius:12px; overflow:hidden; border:1px solid var(--border);
  background:#f3f4f6; height:180px;
}
.cn-previewLeft img{ width:100%; height:100%; object-fit:cover; }
.cn-previewImgStub{
  position:absolute; inset:0; display:flex; align-items:center; justify-content:center; color:#475569;
  background:repeating-linear-gradient(45deg,#f3f4f6,#f3f4f6 8px,#eef2f7 8px,#eef2f7 16px);
}
.cn-badge{
  position:absolute; left:10px; bottom:10px;
  background:#e8f5ee; color:#166534; border:1px solid #b6e2c3;
  border-radius:999px; padding:4px 10px; font-size:11px; text-transform:uppercase; letter-spacing:.5px;
}
.cn-previewRight{ display:flex; flex-direction:column; gap:8px; }
.cn-kicker{ font-size:12px; text-transform:uppercase; color:#475569; letter-spacing:.5px; }
.cn-cta{ color:#334155; }
`;
